import React from 'react';
import { Hammer, Leaf, Palette, Award } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language].about;
  
  const values = [
    {
      icon: Hammer,
      title: t.values.craftsmanship.title,
      description: t.values.craftsmanship.description
    },
    {
      icon: Leaf,
      title: t.values.harmony.title,
      description: t.values.harmony.description
    },
    {
      icon: Palette,
      title: t.values.design.title,
      description: t.values.design.description
    },
    {
      icon: Award,
      title: t.values.excellence.title,
      description: t.values.excellence.description
    }
  ];

  return (
    <section id="about" className="py-24 lg:py-32 bg-[#FAFAF8]">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-20 fade-in">
          <p className="text-[#8B7355] text-sm tracking-widest uppercase mb-4">{t.sectionLabel}</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-['Cormorant_Garamond'] font-light text-[#2c2c2c] mb-6">
            {t.title}
          </h2>
          <div className="w-24 h-0.5 bg-[#8B7355] mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 leading-relaxed">
            {t.description}
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <div
                key={index}
                className="text-center group hover-lift bg-white p-8 rounded-sm shadow-sm hover:shadow-xl transition-all duration-300"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#F5F0E8] rounded-full mb-6 group-hover:bg-[#8B7355] transition-colors duration-300">
                  <Icon className="text-[#8B7355] group-hover:text-white transition-colors duration-300" size={28} />
                </div>
                <h3 className="text-xl font-semibold text-[#2c2c2c] mb-4">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            );
          })}
        </div>

        {/* Story Section */}
        <div className="mt-24 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h3 className="text-3xl md:text-4xl font-['Cormorant_Garamond'] font-light text-[#2c2c2c]">
              {t.storyTitle}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {t.storyPara1}
            </p>
            <p className="text-gray-600 leading-relaxed">
              {t.storyPara2}
            </p>
          </div>
          <div className="relative h-96 lg:h-full min-h-[400px] rounded-sm overflow-hidden shadow-xl">
            <img
              src="https://images.pexels.com/photos/6692145/pexels-photo-6692145.jpeg"
              alt="Japanese craftsmanship"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;